module.exports = __webpack_public_path__ + "static/define-4fb0d8fa647946c0f22f7c5c31febae1.jpg";